import validator, { MobilePhoneLocale } from 'validator';
import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';
import { LOCALE } from '@/utils/constants';
import dayjs from 'dayjs';

export const formatPhoneNumber = (phoneNumber: string, countryCode: string = 'SE'): string => {
  try {
    const countryCodeCast = countryCode.toUpperCase() as CountryCode;

    const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCodeCast);
    if (parsedNumber && parsedNumber.isValid()) {
      return parsedNumber.formatNational();
    }

    const locale = (LOCALE[countryCodeCast] || 'any') as MobilePhoneLocale;

    const isValid = validator.isMobilePhone(phoneNumber, locale, { strictMode: false });

    if (isValid) {
      const cleanedNumber = phoneNumber.replace(/\D/g, '');
      return fallbackFormat(cleanedNumber);
    }

    vtlog('Invalid phone number:', phoneNumber);
    return phoneNumber;
  } catch (error) {
    console.error('Error formatting phone number:', error);
    return phoneNumber;
  }
};

const fallbackFormat = (number: string) => {
  if (number.length === 10) {
    return `${number.slice(0, 3)}-${number.slice(3, 6)} ${number.slice(6, 8)} ${number.slice(8)}`;
  } else if (number.length === 9) {
    return `${number.slice(0, 2)}-${number.slice(2, 5)} ${number.slice(5, 7)} ${number.slice(7)}`;
  }
  return number;
};

export const formatCreditCardNumber = (cardNumber: string) => {
  try {
    const cleanedNumber = cardNumber.replace(/\s+/g, '');
    const groups = cleanedNumber.match(/.{1,4}/g);
    return groups ? groups.join(' ') : cardNumber;
  } catch (error) {
    console.error('Error formatting credit card number:', error);
    return cardNumber;
  }
};

export const formatIsoDateString = (dateString: string) => {
  try {
    return dayjs(dateString).format('YYYY-MM-DD');
  } catch (error) {
    console.error('Error formatting date:', error);
    return dateString;
  }
};
